(function($) {
  $('.back-to-top').on('click', function() {
    if ($(this).closest('.page--home').length === 0) {
      $('html, body').animate({
        scrollTop: 0
      })
    }
  });
})(jQuery);
